export default __webpack_public_path__ + "assets/northbank_logo.15b55f35.svg";